import './style/index.js';

import _Typography from './Typography';

export * from './type';

export const Typography = _Typography;
export default Typography;
